import { render, staticRenderFns } from "./ProductDetailView.vue?vue&type=template&id=703e8e6a&scoped=true"
import script from "./ProductDetailView.vue?vue&type=script&lang=js"
export * from "./ProductDetailView.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailView.vue?vue&type=style&index=0&id=703e8e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703e8e6a",
  null
  
)

export default component.exports